import {
	Alignment,
	Autoformat,
	AutoLink,
	BlockQuote,
	Bold,
	ClassicEditor,
	Essentials,
	FindAndReplace,
	FontBackgroundColor,
	FontColor,
	FontSize,
	Heading,
	Highlight,
	HorizontalLine,
	Indent,
	Italic,
	List,
	ListProperties,
	Paragraph,
	PasteFromOffice,
	RemoveFormat,
	Strikethrough,
	Subscript,
	Superscript,
	Table,
	TableCellProperties,
	TableColumnResize,
	TableProperties,
	TableToolbar,
	TextTransformation,
	Underline,
	type EditorConfig,
} from "ckeditor5"

const editorConfig: EditorConfig = {
	toolbar: {
		items: [
			"undo",
			"redo",
			"|",
			"heading",
			"bold",
			"italic",
			"underline",
			"strikethrough",
			"|",
			"alignment",
			"fontSize",
			"fontColor",
			"fontBackgroundColor",
			"highlight",
			"|",
			"bulletedList",
			"numberedList",
			"|",
			"blockQuote",
			"insertTable",
			"|",
			"outdent",
			"indent",
		],
		shouldNotGroupWhenFull: false,
	},
	plugins: [
		Alignment,
		Autoformat,
		AutoLink,
		BlockQuote,
		Bold,
		Essentials,
		FindAndReplace,
		FontBackgroundColor,
		FontColor,
		FontSize,
		Heading,
		Highlight,
		HorizontalLine,
		Indent,
		Italic,
		List,
		ListProperties,
		Paragraph,
		PasteFromOffice,
		RemoveFormat,
		Strikethrough,
		Subscript,
		Superscript,
		Table,
		TableCellProperties,
		TableColumnResize,
		TableProperties,
		TableToolbar,
		TextTransformation,
		Underline,
	],
	fontSize: {
		options: [10, 12, 14, "default", 18, 20, 22],
		supportAllValues: true,
	},
	heading: {
		options: [
			{
				model: "paragraph",
				title: "Paragraph",
				class: "ck-heading_paragraph",
			},
			{
				model: "heading1",
				view: "h1",
				title: "Heading 1",
				class: "ck-heading_heading1",
			},
			{
				model: "heading2",
				view: "h2",
				title: "Heading 2",
				class: "ck-heading_heading2",
			},
			{
				model: "heading3",
				view: "h3",
				title: "Heading 3",
				class: "ck-heading_heading3",
			},
			{
				model: "heading4",
				view: "h4",
				title: "Heading 4",
				class: "ck-heading_heading4",
			},
			{
				model: "heading5",
				view: "h5",
				title: "Heading 5",
				class: "ck-heading_heading5",
			},
			{
				model: "heading6",
				view: "h6",
				title: "Heading 6",
				class: "ck-heading_heading6",
			},
		],
	},
	licenseKey: "GPL",
	link: {
		addTargetToExternalLinks: true,
		defaultProtocol: "https://",
	},
	list: {
		properties: {
			styles: true,
			startIndex: true,
			reversed: true,
		},
	},
	table: {
		contentToolbar: ["tableColumn", "tableRow", "mergeTableCells", "tableProperties", "tableCellProperties"],
	},
}

export { ClassicEditor, editorConfig }
